import brands from './brands.js';
import light from './light.js';
import regular from './regular.js';
import solid from './solid.js';

export { brands, light, regular, solid };
